import styled from "styled-components";
import { Color } from "../../../../../../themes/definitions/casino777/casino777-colors";
import {hexToRgba} from "../../../../../../themes/hex-to-rgba";
import {LiveCasinoGridItemBetIntervalDefaultBox} from "./live-casino-grid-item-bet-interval.default.box"

export const LiveCasinoGridItemBetIntervalCasino777Box = styled(LiveCasinoGridItemBetIntervalDefaultBox)`
    color: ${props => props.theme.colors.bodyText};
    background: ${props => hexToRgba(props.theme.colors.buttonLight, 0.95)}; /** Color.brandYellow */
    border: 1px solid ${() => hexToRgba(Color.sepia, 0.1)}; /** Color.sepia */
`;
